import { useState } from "react";
import api from "../../utils/api";
import "./styles.scss";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess(false);

        try {
            const response = await api.post("/reset-password", { email });

            if (response.data.success) {
                setSuccess(true);
                setEmail("");
            } else {
                setError(response.data.message || "Erro ao enviar email");
            }
        } catch (err) {
            setError("Erro ao conectar com o servidor");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="forgot-password">
            <div className="forgot-password__container">
                <div className="forgot-password__header">
                    <div className="forgot-password__icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <h2 className="forgot-password__title">Esqueceu sua senha?</h2>
                    <p className="forgot-password__subtitle">
                        Sem problemas! Digite seu email e enviaremos um link para recuperação.
                    </p>
                </div>

                {success && (
                    <div className="forgot-password__message forgot-password__message--success">
                        <svg className="forgot-password__message-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                            <p className="forgot-password__message-title">Email enviado com sucesso!</p>
                            <p className="forgot-password__message-text">
                                Verifique sua caixa de entrada e spam.
                            </p>
                        </div>
                    </div>
                )}

                {error && (
                    <div className="forgot-password__message forgot-password__message--error">
                        <svg className="forgot-password__message-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p>{error}</p>
                    </div>
                )}

                <form className="forgot-password__form" onSubmit={handleSubmit}>
                    <div className="forgot-password__field">
                        <label htmlFor="email" className="forgot-password__label">
                            Email
                        </label>
                        <div className="forgot-password__input-wrapper">
                            <svg className="forgot-password__input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <input
                                id="email"
                                type="email"
                                className="forgot-password__input"
                                placeholder="seu@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <button 
                        type="submit" 
                        className="forgot-password__button"
                        disabled={loading}
                    >
                        {loading ? "Enviando..." : "Enviar Link de Recuperação"}
                    </button>
                </form>

                <div className="forgot-password__footer">
                    <a href="/login" className="forgot-password__back-link">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Voltar para o login
                    </a>
                </div>
            </div>

            <div className="forgot-password__info">
                <p>O link de recuperação expira em 1 hora</p>
            </div>
        </div>
    );
}